"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useFiltersStore } from "@/store/useFilterStore";

export function useMetaTitle(fallback: string) {
  const pathname = usePathname();
  const {
    selectedState,
    selectedCity,
    selectedCategory,
    selectedDateRange,
  } = useFiltersStore();
  const [metaTitle, setMetaTitle] = useState<string>(fallback);

  useEffect(() => {
    if (typeof document !== "undefined") {
      setMetaTitle(document.title || fallback);
    }
  }, [
    pathname,
    selectedState?.label,
    selectedCity?.label,
    selectedCategory?.label,
    selectedDateRange,
    fallback,
  ]);

  return metaTitle;
}
